import { render, staticRenderFns } from "./gzbm.vue?vue&type=template&id=558a776e&scoped=true&"
import script from "./gzbm.vue?vue&type=script&lang=js&"
export * from "./gzbm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a776e",
  null
  
)

export default component.exports